module.exports = new __parcel__URL__("people-working-on-computers.f32ebb44.svg").toString();